export default __webpack_public_path__ + "static/media/img-office.ae25181b.jpg";